<template lang="html">
  <div class="draft-payment-block" v-if="showDraftBlock">
    <div class="draft-payment-container">
      <div class="purchased" v-if="showPaymentSuccessful">
        <div>
          <i class="fas fa-check-circle"></i>
          <span>Purchased</span>
        </div>

        <br />

        <h3>The draft is resuming now. Get ready!</h3>
      </div>

      <div v-else>
        <h3>
          We hope you've enjoyed the draft so far.
          Unfortunately this is the time that we ask for your money.
          We will continue the draft immediately after payment!
        </h3>

        <br />

        <draft-payment center @success="handleSuccess" />

        <router-link
          class="back"
          :to="`/draft/${draft.id}/settings`"
          title="Back to settings"
        >
          Back to settings page
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import DraftPayment from '@/components/DraftPayment';

export default {
  components: {
    DraftPayment,
  },

  data() {
    return {
      showPaymentSuccessful: false,
      showDraftBlock: false,
    };
  },

  mounted() {
    this.checkBlockDraft();
  },

  computed: {
    ...mapState({
      draft: ({ draft }) => draft.draft,
    }),

    blockDraft() {
      return this.draft.status === 'blocked';
    },
  },

  watch: {
    blockDraft() {
      this.checkBlockDraft();
    },
  },

  methods: {
    checkBlockDraft() {
      setTimeout(() => {
        this.showDraftBlock = this.blockDraft;
      }, 5000);
    },

    handleSuccess() {
      this.showPaymentSuccessful = true;

      setTimeout(() => {
        this.$store.dispatch('draft/START_DRAFT');
        this.showPaymentSuccessful = false;
      }, 5000);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-payment-block {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: $transparent-background;
    z-index: $zindex-modal;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .draft-payment-container {
    background-color: $white-color;
    padding: $gp * 1.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: px-to-rem(640px);
    text-align: center;
  }

  .purchased {
    color: $success-color;
    font-size: 20px;
  }

  .back {
    display: block;
    margin-top: $gp * 2;
  }
</style>
